import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function I() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.prelaunch');
    const [active, setActive] = useState(0);

    const cards: any[] = [
        {
            img: '/responsive/picture/delta-pro-ultra/prelaunch/i_1.jpg',
            tab: t('secI_card1_tab'),
            number: t('secI_card1_number'),
            capacity: t('secI_card1_capacity'),
            voltage: t('secI_card1_voltage'),
            input: t('secI_card1_input'),
        },
        {
            img: '/responsive/picture/delta-pro-ultra/prelaunch/i_2.jpg',
            tab: t('secI_card2_tab'),
            number: t('secI_card2_number'),
            capacity: t('secI_card2_capacity'),
            voltage: t('secI_card2_voltage'),
            input: t('secI_card2_input'),
        },
        {
            img: '/responsive/picture/delta-pro-ultra/prelaunch/i_3.jpg',
            tab: t('secI_card3_tab'),
            number: t('secI_card3_number'),
            capacity: t('secI_card3_capacity'),
            voltage: t('secI_card3_voltage'),
            input: t('secI_card3_input'),
        },
    ];

    return (
        <div id="delta-pro-ultra-prelaunch-I" className={`delta-pro-ultra-I off-grid-box ${css['delta-pro-ultra-I']}`}>
            <h2 className="title">{t('secI_title')}</h2>
            <ul className="cards">
                {cards?.map((card: any, k: number) => (
                    <li className={`card ${active === k ? 'active' : ''}`} key={k}>
                        <div className="card-img">
                            <EFPicture src={card?.img} alt={card?.tab} />
                        </div>
                        <div className="card-info">
                            <div className="card-features">
                                <div className="card-feature long">
                                    <p className="card-title">{t('secI_feature_number')}</p>
                                    <p className="card-desc">{card?.number}</p>
                                </div>
                                <div className="card-feature">
                                    <p className="card-title">{t('secI_feature_capacity')}</p>
                                    <p className="card-desc">{card?.capacity}</p>
                                </div>
                                <div className="card-feature">
                                    <p className="card-title">{t('secI_feature_voltage')}</p>
                                    <p className="card-desc">{card?.voltage}</p>
                                </div>
                                <div className="card-feature">
                                    <p className="card-title">{t('secI_feature_input')}</p>
                                    <p className="card-desc">{card?.input}</p>
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
            <ul className="tabs">
                {cards?.map((card: any, k: number) => (
                    <li className={`tab ${active === k ? 'active' : ''}`} key={k} onClick={() => setActive(k)}>
                        {card?.tab}
                    </li>
                ))}
            </ul>
        </div>
    );
}
